// extracted by mini-css-extract-plugin
export default {"default_btn":"styles_default_btn__3hcnt","default_btn_md":"styles_default_btn_md__VXKvD"};